var render = function render(){var _vm=this,_c=_vm._self._c;return _c('com-page',[_c('com-card',[_c('dateSelect',{on:{"on-date":_vm.handleData,"on-export":_vm.handleExport}})],1),_c('com-card',{staticClass:"mt-15px"},[_c('com-table',{ref:"table",attrs:{"columns":_vm.columns,"api":_vm.api}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }